/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { DashboardLayout } from "../components/Dashboard";
import { updateStatusApi } from '../api/services-third-parties';
import Flag from 'react-world-flags'
import { ArrowDownTrayIcon, EyeIcon } from '@heroicons/react/24/outline';
import { ModalOperation } from '../components/ModalOperation';
import {
    ValidAccessToken,
    currencyFormatter,
    formatDate,
    formatDate_ddMMYY,
    formatDate_ddMMYYYY,
    formatDecimal,
    format_idByDigit,
    pagesRouter,
    stringMin
} from '../core/function/function-generic';
import { TypeOperations } from '../core/enum';
import { Tooltip } from '../components/Tooltip';
import { TableGen2 } from '../components/table-gen-2';
import { StatusType } from '../components/StatusType';
import { Currency } from '../components/Currency';
import { FromTransaction, ToTransaction } from '../components/FromTransaction';
import LoadingComponent from '../components/loading/loading';
import { HomeController } from '../core/controller/HomeCtrl';
import CardComponent from '../components/card';

export const Home = () => {
    let countRender = 0
    const homeController = new HomeController()
    const location = useLocation();
    const [dataTable, setDataTable] = useState({
        divContent: 'table-info w-[82%] sm:w-[82%] md:w-full lg:w-full xl:w-full h-[60vh]',
        classTable: 'w-full min-w-max table-auto',
        columns: [
            {
                nameColumn: "Name",
                keysColumns: 'name',
                classThHead: 'pl-6 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[1rem] font-bold bg-[#f9fafb]',
                classStyles: 'py-6 pl-6 text-justify text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-5'
            },
            {
                nameColumn: "Date",
                keysColumns: 'dateNew',
                classThHead: 'pl-4 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[1rem] font-bold bg-[#f9fafb]',
                classStyles: 'py-6 pl-4 text-justify text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-5'
            },
            {
                nameColumn: "Amount",
                keysColumns: 'cash_amount',
                classThHead: 'pl-4 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[1rem] font-bold bg-[#f9fafb]',
                classStyles: 'py-6 pl-4 text-justify '
            },
            {
                nameColumn: "Country",
                keysColumns: 'country',
                classThHead: 'pl-4 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[1rem] font-bold bg-[#f9fafb]',
                classStyles: 'py-6 pl-4 text-justify  text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-5'
            },
            {
                nameColumn: "Method",
                keysColumns: 'method',
                classThHead: 'pl-4 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[1rem] font-bold bg-[#f9fafb]',
                classStyles: 'py-6 pl-4 text-justify  text-justify text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-5'
            },
            {
                nameColumn: "Status",
                keysColumns: 'status',
                classThHead: 'pl-4 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[1rem] font-bold bg-[#f9fafb]',
                classStyles: 'pt-[2.5rem] pl-4 text-justify  flex justify-start text-[#475467] text-[1rem] not-italic font-[Inter] font-normal leading-[0.7px]'
            },
            {
                nameColumn: "ID",
                keysColumns: 'id2',
                classThHead: 'pl-4 text-justify text-[#00000080] font-[Montserrat] leading-[22px] not-italic text-[1rem] font-bold bg-[#f9fafb]',
                classStyles: 'py-6 pl-4 text-justify  text-[#475467] text-[1rem] not-italic font-[Inter] font-bold leading-5 '
            },
        ],
        data: [],
        classTrBody: 'bord-th-body-table',
        totalPages: 0,
        isAction: true,
        actionIcon: [],
        iconClass: `border-fff`
    });

    const [dataWithdrawal, setWithdrawal] = useState([]);
    const [digitId, setdigitId] = useState(-4);
    const [open, setOpen] = useState(false);
    const [isLoading, setisLoading] = useState(false);
    const [dataOperation, setdataOperation] = useState(false);
    const [dataDashboard, setdataDashboard] = useState(false);
    const [pagesPagination, setpagesPagination] = useState(1);
    const [dataCard, setdataCard] = useState([])

    const navigate = useNavigate();
    const state = useSelector((state) => state.business);

    useEffect(() => {
        setdigitId(-4)
        ValidAccessToken()
        getDashboard(state.id);
        getTransactionByBusiness(state.id, '15 days', pagesPagination, 10, state.typeBusiness)
    }, []);

    const getTransactionByBusiness = async (idBusiness, period, pages, take, typeOperation) => {
        try {
            setisLoading(true)
            const response = await homeController.getTransactionByBusiness(idBusiness, period, pages, take, typeOperation)
            if (state.typeBusiness === 'OUT') responseRequest(response)
            else responseRequestIn(response)
        } catch (error) {
            setisLoading(false)
            console.error('Error en getTransactionByBusiness:', error);
        }
    }

    const getDashboard = async (id) => {
        try {
            const response = await homeController.getDashboardByBusiness(id, state.typeBusiness)
            const dataMapDashboard = await homeController.mapDashboard(response['data']['data'])
            setdataCard(dataMapDashboard)
            setdataDashboard(response['data']['data']);
        } catch (err) {
            console.error(err);
        }
    }

    const getRetriveCMS = async (idTXTrsnaction) => {
        try {
            const response = await homeController.getTransactionRetriveCmsById(idTXTrsnaction)
            return dataMapRetriveCMS(response['data']['data'])
        } catch (err) {
            console.error(err);
        }
    }

    const dataMap = (row) => {
        return row.map((item) => {
            const dataFrom = item.from.split('-')
            const dataTo = item.to.split('-')
            return {
                name: item.name,
                from: state.typeBusiness === 'OUT' ? (
                    <ToTransaction
                        nameBank={item.to.includes('NO CUSTODIAL') ? dataTo[0] + ' ' + dataTo[2] : dataTo[0]}
                        address={dataTo[1]}
                    />
                ) : (
                    <FromTransaction
                        nameMoney={dataFrom[0]}
                        address={dataFrom[1]}
                        red={dataFrom[2]}
                    />
                ),
                to: state.typeBusiness === 'OUT' ? (
                    <FromTransaction
                        nameMoney={dataFrom[0]}
                        address={dataFrom[1]}
                        red={dataFrom[2]}
                    />
                ) : (
                    <ToTransaction
                        nameBank={dataTo[0]}
                        address={dataTo[1]}
                    />
                ),
                phoneNumber: item.phoneNumber,
                email: item.email,
                date: formatDate(item.date),
                enddateNew: formatDate_ddMMYYYY(item.date),
                dateNew: (
                    <Tooltip
                        name={formatDate_ddMMYY(item.date)}
                        nameTooltip={formatDate(item.date)}
                    />
                ),
                cash_amount: (
                    <Currency
                        amount={item.amount}
                        currencyFrom={item.currencyOrigin}
                        currencyTo={item.currency}
                    />
                ),
                amount: currencyFormatter({
                    currency: "USD",
                    value: item.amount
                }),
                rate: formatDecimal(item.rate),
                country: (
                    <>
                        <Flag
                            className="h-[1.0rem] inline-block"
                            code={item.country} />{/* <span className='ml-[10px]'></span> */}
                    </>
                ),
                id: item.idTransaction,
                id2: format_idByDigit(item.idTransaction, digitId),
                statusName: item.status,
                status: (<StatusType name={item.status} idTransaction={item.id} handleChangeStatus={handleChangeStatus} />),
                method: (item.method.toLowerCase() === 'atm') ? item.method.toUpperCase() : stringMin(item.method)
            }
        })
    }

    const dataMapRetriveCMS = (row) => {

        const dataFrom = row.detailFrom.split('-');
        const dataTo = row.detailTo.split('-');
        return {
            name: row.legalname,
            email: row.email,
            phoneNumber: row.phone,
            typeOperation: TypeOperations[row.type],
            from: state.typeBusiness === 'OUT' ? (
                <ToTransaction
                    nameBank={dataTo[0]}
                    address={dataTo[1]}
                />
            ) : (
                <FromTransaction
                    nameMoney={dataFrom[0]}
                    address={dataFrom[1]}
                    red={dataFrom[2]}
                />
            ),
            to: state.typeBusiness === 'OUT' ? (
                <FromTransaction
                    nameMoney={dataFrom[0]}
                    address={dataFrom[1]}
                    red={dataFrom[2]}
                />
            ) : (
                <ToTransaction
                    nameBank={dataTo[0]}
                    address={dataTo[1]}
                />
            ),
            idTransaction: row.idTransaction
        }
    }

    const dataMapIn = (row, typeOperationIn) => {

        return row.map((item) => {
            return {
                name: item.method.user,
                transaction: item.method.transaction,
                typeOperationTransaction: typeOperationIn,
                startdate: (
                    <Tooltip
                        name={formatDate_ddMMYY(item.start_time)}
                        nameTooltip={formatDate(item.start_time)}
                    />
                ),
                enddate: (
                    <Tooltip
                        name={formatDate_ddMMYY(item.end_time)}
                        nameTooltip={formatDate(item.end_time)}
                    />
                ),
                enddateNew: formatDate_ddMMYYYY(item.method.date),
                method: stringMin(item.method.cashout),
                chain: stringMin(item.chain),
                currency: item.currency,
                cash_amount: (
                    <Currency
                        amount={item.method.cash_amount}
                        currencyFrom={item.method.currency_pay}
                        currencyTo={item.currency}
                    />
                ),
                amount: currencyFormatter({
                    currency: "USD",
                    value: item.method.cash_amount
                }),
                status: (<StatusType name={item.method.status} idTransaction={item.id} handleChangeStatus={handleChangeStatus} />),
                statusName: item.method.status,
                kyb: item.method.KYB,
                country: (
                    <>
                        <Flag className="h-[1.0rem] inline-block" code={item.method.country_withdraw} />
                        <span className='ml-[10px]'></span>
                    </>
                ),
                countryName: item.method.country_withdraw,
                cashout: item.method.cashout,
                time_payout: item.method.time_payout,
                time_estimate_payout: item.method.time_estimate_payout,
                id: item.id,
                id2: format_idByDigit(item.id, digitId),
                date: formatDate(item.method.date),
                dateNew: (
                    <Tooltip
                        name={formatDate_ddMMYY(item.method.date)}
                        nameTooltip={formatDate(item.method.date)}
                    />
                ),
                txTransaction: item.method.transaction
            }
        })

    }

    const responseRequestIn = (response) => {
        if ([202].includes(response.data.statusCode)) {
            setisLoading(false)
            setWithdrawal([]);
            const res = response.data['data']['data'];
            const totalPages = response['data']['data']['meta']['pageCount'];

            setWithdrawal(res);
            setDataTable((prevDataTable) => ({
                ...prevDataTable,
                data: dataMapIn(res),
                actionIcon: activeTypeBusinnes(state.typeBusiness),
                totalPages: totalPages
            }));
        }
    }

    const responseRequest = (response) => {
        if ([400].includes(response.data.statusCode)) {
            setisLoading(false)
            setWithdrawal([]);
            setDataTable((prevDataTable) => ({
                ...prevDataTable,
                totalPages: 1
            }));
        }

        if ([202].includes(response.data.statusCode)) {
            setisLoading(false)
            const res = response.data['data']['data'];
            const totalPages = response['data']['data']['meta']['pageCount'];

            setWithdrawal(res);
            setDataTable((prevDataTable) => ({
                ...prevDataTable,
                data: dataMap(res),
                actionIcon: activeTypeBusinnes(state.typeBusiness),
                totalPages: totalPages
            }));
        }
    }

    const handleChangeStatus = async (event, idTransaction) => {
        if (['COMPLETED', 'REJECTED'].includes(event)) {

            const params = {
                id: idTransaction,
                status: event === 'COMPLETED' ? true : false,
                refPayment: `A status change from PENDING to ${event} was made for transaction ${idTransaction}`,
                business: state.id
            }

            const { status } = await updateStatusApi(params);
            if (status === 200) {
                getTransactionByBusiness(state.id, '15 days', pagesPagination, 10, state.typeBusiness)
            }
            return;
        }
    }

    const activeTypeBusinnes = (typeBusiness) => {
        if (typeBusiness === 'OUT') {
            return [
                { icon: <ArrowDownTrayIcon className='w-[1.5rem] color-Logout cursor-pointer' />, action: 'download' },
                { icon: <EyeIcon className='w-[1.5rem] color-Logout cursor-pointer' />, action: 'view' },
                /* { icon: <PencilIcon className='w-[1.5rem] color-Logout cursor-pointer'/>, action:'edit' }, */
            ]
        } else {
            return [
                { icon: <EyeIcon className='w-[1.5rem] color-Logout cursor-pointer' />, action: 'view' },
            ]
        }
    }

    const handleNextPageClick = (e) => {
        setpagesPagination((e.selected + 1))
        getTransactionByBusiness(state.id, '15 days', (e.selected + 1), 10, state.typeBusiness)
    }

    const handleEdit = (id, action) => {
        navigate((action === 'edit') ? `/edit/${id}` : `/download`);
    }

    const onAction = (e) => {
        if (['edit'].includes(e.action)) {
            if (['pending'].includes(e.data.statusName.toLowerCase())) {
                handleEdit(e.id, e.action);
            }
        }

        if (['download'].includes(e.action)) {
            handleEdit(e.id, e.action);
        }
        if (e.action === 'view') handleOpen(e.data);
    }

    const handleOpen = async (row) => {
        if (state.typeBusiness === 'OUT') {
            //const data = await getRetriveCMS(row.id)
            setdataOperation({ ...row });
            setOpen(true)
        } else {
            const data = await getRetriveCMS(row.transaction)
            setdataOperation({ ...row, ...data });
            setOpen(true)
        }
    }

    const closeModal = (e) => {
        setOpen(e);
    }

    return (
        <>
            <LoadingComponent isOpen={isLoading} />
            <DashboardLayout pageTitle={pagesRouter(location.pathname)}>
                <ModalOperation
                    operationDetails={dataOperation}
                    isOpen={open} closeModal={closeModal}
                    typeOperation={'transactions'} />
                {/* <SectionTap onsearchFilter={onsearchFilter} /> */}
                {['Dashboard'].includes(pagesRouter(location.pathname)) && (
                    <>
                        <CardComponent CardDataOption={dataCard} classNames={'grid md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 gap-4 mb-8'} />
                    </>
                )}

                <TableGen2
                    dataTableGen={dataTable}
                    handleNextPageClick={handleNextPageClick}
                    onAction={onAction} />

            </DashboardLayout>
        </>
    )
}